import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent {
  constructor(
    public dialog: MatDialog
  ) { }

  openJivoChat() {
    if (window['jivo_api']) {
      window['jivo_api'].open();
    }
  }

}
